import { render, staticRenderFns } from "./StudioTips.vue?vue&type=template&id=1bb0f7a3&scoped=true&"
import script from "./StudioTips.vue?vue&type=script&lang=ts&"
export * from "./StudioTips.vue?vue&type=script&lang=ts&"
import style0 from "./StudioTips.vue?vue&type=style&index=0&id=1bb0f7a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0f7a3",
  null
  
)

export default component.exports